import { writable } from 'svelte/store';

export let filterDashboardTemplatesQuery = writable<string>('');
export let filterDashboardTemplatesSelectedPermission = writable<string>('private'); // all | private | public